import { EMPTY_CHARACTER } from "Constants";
import { isString } from "lodash";

import { Customer } from "../models/customer";
import { Fleet } from "../models/fleet";

export const getCustomerFullname = (customer?: Customer) => {
  if (!customer?.name && !customer?.fullName) return "";

  if (customer?.fullName) return customer?.fullName;

  return `${customer.name} ${customer.lastName || ""}`;
};

export const getOrderCustomerDisplayName = (order?: {
  customerFullNameAtCreation?: string;
  customer?: Customer;
  origin?: { customer?: Customer };
}) => {
  const snapshot = order?.customerFullNameAtCreation?.trim();
  if (snapshot) return snapshot;

  if (order?.customer) return getCustomerFullname(order.customer);

  if (order?.origin?.customer) return getCustomerFullname(order.origin.customer);

  return "";
};

/**
 * @description A function that receives a user and return his full name.
 * @param user {User} The user object
 * @returns fullName {string} The full name of the user
 */
export const getUserFullname = (
  user?: Partial<{ name: string; lastName: string; fullName: string }>
) => {
  if (!user || (!user.name && !user.fullName)) return "";

  if (user?.fullName) return user?.fullName;

  return `${user.name} ${user.lastName || ""}`;
};

export const getFleetName = (fleet?: Fleet) => {
  if (!fleet) return "";

  const fleetNumber = fleet.fleetNumber || "";
  const licensePlate = fleet.licensePlate || "";
  const haveBoth = !checkIsEmpty(fleetNumber, licensePlate);

  return `${fleetNumber} ${haveBoth ? "-" : ""} ${licensePlate}`.trim();
};

export const getStaffFullname = (
  staff?: Partial<{ firstName: string; lastName: string; fullName: string }>
) => {
  if (!staff || (!staff.firstName && !staff.fullName)) return "";

  const name = staff.firstName || "";
  const lastName = staff.lastName || "";

  if (staff?.fullName) return staff?.fullName;

  return `${name} ${lastName}`.trim();
};

const checkIsEmpty = (...args: string[]) => {
  return args.map((arg) => arg.trim()).filter(Boolean).length !== args.length;
};

export const renderEmptyString = (string: React.ReactNode, emptyString?: string) => {
  if (
    string === undefined ||
    string === null ||
    (isString(string) && string.trim().length === 0) ||
    (Array.isArray(string) && string.length === 0)
  ) {
    return emptyString ?? EMPTY_CHARACTER;
  }

  return string;
};
